import React, { useContext, useState, useRef } from "react";
import { useDraggable, useDroppable } from "@dnd-kit/core";
import { DataContext } from "../DataContext";

const AvailableList = ({ onDrop, onGetGoal }) => {
  const { data } = useContext(DataContext);

  const { setNodeRef } = useDroppable({
    id: "available",
  });

  return (
    <div 
      className="droppable available section" 
      ref={setNodeRef} 
      onDrop={(event) => onDrop(event, "available")}
    >
      <div className="categoryTitle">
        Fila <span className="categorQuantity">({data.available.length})</span>
      </div>
      <div className="card-container">
        {data.available.map((item, index) => (
          <DraggableCard key={item.uuid} item={item} index={index} onGetGoal={onGetGoal} />
        ))}
      </div>
    </div>
  );
};

const DraggableCard = ({ item, index, onGetGoal }) => {
  const S3_URL = process.env.REACT_APP_S3_URL;
  
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: item.uuid,
    data: { itemId: item.uuid, sourceCategory: "available" },
  });

  // eslint-disable-next-line
  const [tapCount, setTapCount] = useState(0);
  const lastTapRef = useRef(0);
  const timeoutRef = useRef(null);

  const handlePointerUp = (event) => {
    // Ignore if dragging
    if (event.pointerType === "mouse" && (Math.abs(event.movementX) > 1 || Math.abs(event.movementY) > 1)) {
      return;
    }

    const now = Date.now();
    const timeDiff = now - lastTapRef.current;

    if (timeDiff < 500) {
      setTapCount(prev => {
        const newCount = prev + 1;
        if (newCount === 3) {
          clearTimeout(timeoutRef.current);
          onGetGoal(item)
          return 0;
        }
        return newCount;
      });

      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setTapCount(0);
      }, 600);
    } else {
      setTapCount(1);
    }

    lastTapRef.current = now;
  };

  const style = {
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
    touchAction: "none",
    position: "relative",
    zIndex: 1000,
  };

  return (
    <div
      ref={setNodeRef}
      className="card available"
      style={style}
      {...listeners}
      {...attributes}
      id={item.uuid}
      onPointerUp={handlePointerUp}
    >
      <div className="avatar">
        <img src={`${S3_URL}/img/user/${item.avatar_url}`} alt={item.name} className="avatar-img" />
        <span className="avatar-number">{index + 1}</span>
      </div>
      <div className="info">
        <span className="name-with-margin">{item.name}</span>
      </div>
    </div>
  );
};

export default AvailableList;
